<template>
  <div class="home">
    <acuerdo-comercial class="contenedor-principal"></acuerdo-comercial>
  </div>
</template>

<script>
import AcuerdoComercial from '../acuerdo-comercial/AcuerdoComercial.vue';

/**
 * Home de usuario a la que se redirige luego de login exitoso
 *
 * Archivo definido en Core pero que se espera que sea modificado de acuerdo a la lógica de cada satélite.
 */
export default {
  name: 'Home',
  components: {
    AcuerdoComercial
  }
};
</script>

<style lang="scss">
  .home{
    background-color: color(blanco);
    height: 100%;
  }

  .contenedor-principal {
    height: 100%;
    padding: 0 16px 16px !important;
  }
</style>